import { diffChars } from 'diff';
import React, { useMemo } from 'react';

import useHistoryOfChangesContext from 'pages/item/v2/hooks/use-history-of-changes-context';

import useStyles from './styles';

interface Props {
    title: string;
    className?: string;
}

const Title: React.FC<Props> = ({ title, className }) => {
    const { classes, cx } = useStyles();
    const { revision } = useHistoryOfChangesContext();

    const content = useMemo(() => {
        const newValue = (title ?? '').trim();

        if (revision && 'title' in revision.changes) {
            const oldValue = (revision?.changes?.title ?? '').trim();
            const diff = diffChars(oldValue, newValue, { ignoreCase: true });
            return (
                <>
                    {diff.map(({ value, added, removed }, index) => {
                        if (added)
                            return (
                                <span key={index} className={classes.added}>
                                    {value}
                                </span>
                            );
                        if (removed)
                            return (
                                <span key={index} className={classes.removed}>
                                    {value}
                                </span>
                            );
                        return <React.Fragment key={index}>{value}</React.Fragment>;
                    })}
                </>
            );
        }

        return newValue;
    }, [classes.added, classes.removed, revision, title]);

    return <h1 className={cx(classes.header, className)}>{content}</h1>;
};

export default Title;
